// Upload Document Use Case

import Exception from "@/core/exceptions/Exception";
import DefaultExceptionTypes from "@/core/exceptions/DefaultExceptionTypes";
import DocumentUploadRepository from "@/core/customers/repositories/DocumentUploadRepository";
import {
  DocumentUploadRequest,
  DocumentUploadResponse,
} from "@/core/customers/entities/DocumentUpload";

export default class UploadDocumentUseCase {
  constructor(
    private readonly documentUploadRepository: DocumentUploadRepository
  ) {}

  /**
   * Executes the upload document use case.
   *
   * @param request - Document upload request containing file and metadata
   * @returns A promise resolving with DocumentUploadResponse
   * @throws {Exception} If an exception occurs during execution
   */
  async execute(
    request: DocumentUploadRequest
  ): Promise<DocumentUploadResponse> {
    try {
      return await this.documentUploadRepository.uploadDocument(request);
    } catch (e) {
      if ((e as Exception).type) {
        throw e;
      } else {
        throw { type: DefaultExceptionTypes.UNKNOWN_ERROR, body: e };
      }
    }
  }
}
